import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { MenuCardSubLabel } from "../menu/MenuCardSubLabel";
import { MdAddCircle } from "react-icons/md";
import { NPCSensorSingleTriggerPropertiesEditor } from "./NPCSensorSingleTriggerPropertiesEditor";
import { ViewAreaTriggerModel } from "../../../shared/game/ViewAreaTriggerModel";
import { UiConstants } from "../../data/UiConstants";
const AddButton = styled.button.withConfig({
  displayName: "NPCSensorTriggersPropertiesEditor__AddButton",
  componentId: "sc-y9m4j1-0"
})(["cursor:pointer;margin-left:5px;margin-bottom:4px;"]);
const AddIcon = styled(MdAddCircle).withConfig({
  displayName: "NPCSensorTriggersPropertiesEditor__AddIcon",
  componentId: "sc-y9m4j1-1"
})(["vertical-align:bottom;margin-right:2px;"]);
const Container = styled.div.withConfig({
  displayName: "NPCSensorTriggersPropertiesEditor__Container",
  componentId: "sc-y9m4j1-2"
})(["margin-left:5px;border-radius:", ";border:1px black solid;"], UiConstants.BORDER_RADIUS);
export const NPCSensorTriggersPropertiesEditor = observer(({
  npc,
  isCurrentMapPartOfTheModule
}) => {
  const {
    t
  } = useTranslation();

  function addViewTrigger() {
    npc.addViewAreaTrigger(new ViewAreaTriggerModel({}));
  }

  function deleteViewTrigger(trigger) {
    npc.removeViewAreaTrigger(trigger);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuCardSubLabel, null, t("editor.npc_inspector_sensors"), " (", npc.viewAreaTriggers.length, ")"), /*#__PURE__*/React.createElement(AddButton, {
    onClick: addViewTrigger
  }, " ", /*#__PURE__*/React.createElement(AddIcon, null), t("editor.npc_inspector_add_sensor")), npc.viewAreaTriggers.length > 0 && /*#__PURE__*/React.createElement(Container, null, npc.viewAreaTriggers.map(trigger => /*#__PURE__*/React.createElement(NPCSensorSingleTriggerPropertiesEditor, {
    key: trigger.$modelId,
    viewTrigger: trigger,
    onDeleteTrigger: deleteViewTrigger,
    isCurrentMapPartOfTheModule: isCurrentMapPartOfTheModule
  }))));
});